module.exports = __webpack_public_path__ + "img/GO_03.87cd0cf8.png";